import {
  AutocompleteInput,
  type AutocompleteInputProps,
  useGetList,
} from "react-admin";

import { type ModuleValue } from "@/types/modules";

type Props = Omit<AutocompleteInputProps, "resource"> & {
  module: ModuleValue;
};

const STALE_TIME = 60_000;

export const ReferenceAutoCompleteInput = ({ module, ...rest }: Props) => {
  const { isPending, data } = useGetList(
    module,
    { filter: { pagination: false } },
    {
      staleTime: STALE_TIME,
    },
  );

  return (
    <AutocompleteInput {...rest} isPending={isPending} choices={data ?? []} />
  );
};
